// react
import React, { useContext, useState } from "react";
// context
import { FireContext } from "../context/firebase";
// animation pkg
import { motion } from "framer-motion";
import { TailSpin } from "react-loading-icons";
import { useNavigate } from "react-router-dom";

export default function UnderConstruction() {
  const { submitForm } = useContext(FireContext);
  const navigate = useNavigate();
  // Loading state for form
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [alert, setAlert] = useState("Error"); // sets the text for the alert
  const [alertLive, setAlertLive] = useState(false); // spawns the alert
  // Form state for subscribe form
  const [form, setForm] = useState({
    first: "",
    last: "",
    email: "",
  });

  const handleUpdate = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsLoading(true);
      const response = await submitForm(form.first, form.last, form.email);
      if (response.success) {
        setSuccess(response.success);

        Notification(response.message); // should = {success: true, message: "Form submitted successfully."}
        navigate("/thankyou");
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      Notification(error);
    }
  };

  function Notification(text) {
    let timeout = 5000;
    const message = text ?? "";
    setAlert(message);
    setAlertLive(true);

    setTimeout(() => {
      setAlertLive(false);
    }, [timeout]);
  }
  // class config for input fields
  const input_class =
    "h-12 w-full rounded-md bg-primary/5 50 pl-2 text-primary 900 outline-none placeholder:text-primary/60 900";
  // class config for input labels
  const label_class =
    "font-mono text-sm text-left w-full font-extrabold text-primary 800";

  return (
    <main className="flex items-start md:items-center p-2 justify-center w-screen h-screen max-w-full max-h-full md:p-24 select-none md:bg-dark/5">
      <div className="flex absolute top-0 pt-2 visible md:hidden w-full justify-center items-center">
        <img
          className="object-fill h-10 mr-2"
          alt="logo"
          loading="eager"
          src={
            "https://firebasestorage.googleapis.com/v0/b/fir-forever-midwest.appspot.com/o/Logo.svg?alt=media&token=77e7cd03-1f70-4549-996c-b099a8cfe6ae"
          }
        />
        <h1 className="text-4xl text-dark/90  font-bold">
          <span className="text-primary">Art</span>Zipper.com
        </h1>
      </div>
      {/* Background Image */}

      {/* ... for corner, TODO: have licensing and cookies agreement pop up after clicked 
      <div className="absolute bottom-0 right-0 p-2 text-4xl font-bold text-primary 800 transition-colors cursor-pointer hover:text-primary 600">
        ...
      </div>*/}

      <div className="z-10 md:bg-white rounded-md md:shadow-lg p-2 flex-col flex items-center  justify-center font-mono text-sm md:w-96 w-full">
        {/* Logo - Todo, make not draggable */}

        {/* Subscribe Form - TODO: have subscribe form send to firebase */}
        <div className="flex flex-col items-center justify-center h-full w-full md:w-96 max-w-screen">
          <div className="flex md:visible invisible pt-3 w-full justify-center items-center">
            <img
              className="object-fill h-10 mr-2"
              alt="logo"
              loading="eager"
              src={
                "https://firebasestorage.googleapis.com/v0/b/fir-forever-midwest.appspot.com/o/Logo.svg?alt=media&token=77e7cd03-1f70-4549-996c-b099a8cfe6ae"
              }
            />
            <h1 className="text-4xl text-dark  font-bold">
              <span className="text-primary">Art</span>Zipper.com
            </h1>
          </div>
          <form
            action=""
            autoComplete="off"
            aria-autocomplete="none"
            onSubmit={(e) => {
              handleSubmit(e);
            }}
            className=" h-full md:p-5 w-full flex justify-center items-center md:items-start flex-col  md:w-96"
          >
            {/* Header text for form */}
            <h1 className="md:whitespace-nowrap max-md:hidden md:line-clamp-none md:text-2xl/6 text-center md:text-left text-6xl/none font-bold text-primary 600">
              Coming Soon
            </h1>
            <h2 className="pb-2 whitespace-nowrap text-base font-thin text-dark/80">
              Version 2.0 Under Construction.
            </h2>

            {/* name input fields for form */}
            <label className={label_class}>Name</label>
            <div className="flex pb-2 w-full space-x-2">
              <input
                name="first"
                type="text"
                className={input_class}
                placeholder="First"
                value={form.first}
                onChange={(e) => handleUpdate(e)}
                required={false}
              ></input>
              <input
                name="last"
                type="text"
                className={input_class}
                placeholder="Last"
                value={form.last}
                onChange={(e) => handleUpdate(e)}
                required={false}
              ></input>
            </div>

            {/* email input fields for form */}
            <label className={label_class}>Email (Required)</label>
            <input
              name="email"
              type="email"
              className={input_class}
              placeholder="name@email.com"
              value={form.email}
              onChange={(e) => handleUpdate(e)}
              required={true}
            ></input>

            {/* subscribe button */}
            <button
              type="submit"
              className="flex mb-3 relative items-center justify-center w-full h-12 mt-2 text-lg text-white transition-colors bg-primary rounded-md shadow hover:bg-primary/80"
            >
              {isLoading ? (
                <TailSpin className="p-1" stroke="white" />
              ) : (
                "Keep me Updated!"
              )}
            </button>
            <AlertBox />
          </form>
        </div>
      </div>
    </main>
  );
  function AlertBox() {
    return (
      <>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`w-full p-2 text-sm rounded h-fit   outline-1 outline ${
            !alertLive && "hidden"
          } ${
            success
              ? "bg-green-100 outline-green-500"
              : "bg-secondary/10 outline-secondary"
          }`}
        >
          {alert}
        </motion.div>
      </>
    );
  }
}
